import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useEffect, useState } from "react";
import { getCookieValue } from "../../../cookieHelper";
import translate from "../../../i18n/translate";
import "./CultureNotesTopic.scss";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { cultureNotesTopicDD } from "../../../globalConstants";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const CultureNotesTopic: React.FC = () => {
  const navigate = useNavigate();
  const allInfo = useSelector((state: any) => state);
  const categoryLists = cultureNotesTopicDD[0].CategoryList;
  const categoryMaps = cultureNotesTopicDD[0].CategoryMap;
  const [cultureNotesTopicFeatureEnabled, setCultureNotesTopicFeatureEnabled] = useState(true);
  const [categories] = useState(categoryLists);
  const [categoryMap, setCategoryMap] = useState<any>([]);
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [content, setContent] = useState([]);
  const [loaderFlag, setLoaderFlag] = useState(false);

  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && !allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
      if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28) === "1") {
        setCultureNotesTopicFeatureEnabled(true);
      } else {
        setCultureNotesTopicFeatureEnabled(false);
      }
    }
  }, [allInfo.peopleInformation]);

  useEffect(() => {
    localStorage.setItem("categorySelected", categories[0]);
    let categoryMap = categoryMaps.filter((data) => data.Name === categories[0]);
    localStorage.setItem("categoryMapSelected", categoryMap[0].Topics[0]);
    setCategoryMap(categoryMap[0].Topics);
    setCurrentPage(1);
    readFile(true);
  }, []);

  useEffect(() => {
    readFile(true);
  }, [getCookieValue("ulang")]);

  /**
   * Make api to get culture center data
   * @param url
   * @returns
   */
  async function cultureNotesJson(lang: string) {
    setLoaderFlag(true);
    let cultureNotesData: any = await fetch(
      `${process.env.REACT_APP_BLOB_STORAGE}/culturenotestopic/CultureNotes.${lang}.json`,
    )
      .then((res: any) => res.json())
      .then((data: any) => {
        setLoaderFlag(false);
        return data;
      })
      .catch((err: any) => {
        console.log(err, "cultureNotesJson");
        setLoaderFlag(false);
      });
    return cultureNotesData;
  }

  const readFile = async (translationUpdate: boolean) => {
    const lang: string = getCookieValue("ulang") || "EN";
    const data: any = !translationUpdate ? content : await cultureNotesJson(lang);
    if (!data) return;
    setContent(data);
    const arrayIndex: string = localStorage.getItem("categoryMapSelected") + "Bdy";
    const titile1Index: string = localStorage.getItem("categorySelected") || "";
    const title1: string = data[titile1Index];
    const title2 = data[localStorage.getItem("categoryMapSelected") + "Btitle"];
    setText(data[arrayIndex]);
    setTitle(title1 + ": " + title2);
  };

  function handleChange(event: any) {
    let categoryMap = categoryMaps.filter((data) => data.Name === event.target.value);
    localStorage.setItem("categorySelected", event.target.value);
    setCategoryMap(categoryMap[0].Topics);
    localStorage.setItem("categoryMapSelected", categoryMap[0].Topics[0]);
    readFile(false);
    setCurrentPage(1);
  }

  const handleChangeValue = (event: any) => {
    const selectedTopicIndex = Number(event.target.value.slice(-1));
    paginationClick(selectedTopicIndex === 1, selectedTopicIndex);
  };

  /**
   * paginationClick next previous topic
   * @param isPrevBtn
   */
  const paginationClick = (isPrevBtn: boolean = false, selectedIndex: number = 0) => {
    const nextPrev = isPrevBtn ? currentPage - 1 : currentPage + 1;
    const topicPageIndex = selectedIndex ? selectedIndex : nextPrev;
    if (topicPageIndex > 0 && topicPageIndex <= categoryMap.length) {
      localStorage.setItem(
        "categoryMapSelected",
        localStorage.getItem("categorySelected") + "n" + String(topicPageIndex),
      );
      readFile(false);
      setCurrentPage(topicPageIndex);
    }
  };

  const redirecttocultureNotes = () => {
    navigate("/culturenotes");
  };

  return (
    <div className="culturetopics">
      <Container>
        {!loaderFlag ? (
          <React.Fragment>
            {cultureNotesTopicFeatureEnabled ? (
              <React.Fragment>
                <div className="culturetopics-heading">
                <button className="remove-button-default-style" onClick={redirecttocultureNotes}>
                  <h3 data-testid="feature-titleId" >
                    {translate("feature_culture_centre_title")}
                  </h3>
                  </button>
                </div>
                <div className="culturetopics-location">
                  <div className="culturetopics-location-selectbox">
                    <FormControl variant="outlined">
                      <InputLabel id="demo-simple-select-outlined-label-category">
                        {translate("SelectACategory")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label-category"
                        id="Continent"
                        value={localStorage.getItem("categorySelected") || ""}
                        onChange={handleChange}
                        label={translate("SelectACategory")}
                      >
                        {categories.map((option: any, index: number) => {
                          return (
                            <MenuItem key={getRandomNumber(index)} value={option}>
                              {content[option]}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="culturetopics-location-selectbox">
                    <FormControl variant="outlined">
                      <InputLabel id="demo-simple-select-outlined-label-topic">{translate("SAT")}</InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label-topic"
                        id="Countries"
                        value={localStorage.getItem("categoryMapSelected") || ""}
                        onChange={(event) => handleChangeValue(event)}
                        label={translate("SAT")}
                      >
                        {categoryMap.map((option: any, index: number) => {
                          return (
                            <MenuItem key={getRandomNumber(index)} value={option}>
                              {content[option]}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="culturetopics-content">
                  <div className="culturetopics-content-title">
                    {" "}
                    <b>
                      <span dangerouslySetInnerHTML={{ __html: title }} />
                    </b>
                  </div>
                  <div className="culturetopics-content-para">
                    {" "}
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                  </div>
                </div>
                {categoryMap && (
                  <div className="culturetopics-pagination">
                    <div>
                      {currentPage}/{categoryMap?.length}
                    </div>
                    <button
                      data-testid="culturetopicsID"
                      className="culturetopics-pagination-arrowbtn"
                      onClick={() => paginationClick(true)}
                    >
                      <ArrowBackIosIcon className="backArrow"></ArrowBackIosIcon>
                    </button>
                    <Button
                      disabled={currentPage === categoryMap?.length }
                      onClick={() => paginationClick(false)}
                      type="button"
                      variant="contained"
                      color="primary"
                    >
                      <Typography>{translate("button_next")}</Typography>
                    </Button>
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div className="culture-Notes-Location-Errorpage">
                <ErrorPage status={401} />
              </div>
            )}
          </React.Fragment>
        ) : (
          <div
            data-testid="culturecenter-loader-containerId"
            className="culturetopics-loader-container-main culturecenter-loader-container"
          >
            <CircularProgress size={50} color="primary" />
          </div>
        )}
      </Container>
    </div>
  );
};

export default CultureNotesTopic;
